export const AVISO_LEGAL_SHOWING = 'AVISO_LEGAL_SHOWING';
export const PRIVACY_POLICY_SHOWING = 'PRIVACY_POLICY_SHOWING';
export const RSS_POLICY_SHOWING = 'RSS_POLICY_SHOWING';
export const COOKIE_POLICY_SHOWING = 'COOKIE_POLICY_SHOWING';
export const SHOP_CONDITIONS_SHOWING = 'SHOP_CONDITIONS_SHOWING';
export const NEWSLETTER_SHOWING = 'NEWSLETTER_SHOWING';
